import { useParams } from 'react-router-dom';
import { ContentPageView } from '../components/ContentPageView';
import { NotFound } from './NotFound';

/** Generic /p/:slug route — backed entirely by content_pages. */
export function ContentPage() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <NotFound />;
  return <ContentPageView slug={slug} fallback={() => <NotFound />} />;
}
